import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { VenueListComponent, RequestNewVenueComponent } from '../venue-list/venue-list.component';
import { VenueListRoutingModule } from '../venue-list/venue-list-routing.module';

import { AppMaterialModule } from '../../../material/material.module'; 
import { SharedModule } from '../../../shared/shared.module';



@NgModule({
  declarations: [VenueListComponent, RequestNewVenueComponent],
  imports: [
    CommonModule,
    VenueListRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    SharedModule
  ],
  providers:[ ],
  exports: [
    VenueListComponent
  ],
  entryComponents: [RequestNewVenueComponent]
})
export class VenueListModule { }
